import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Card,
    Button,
    Tabs,
    Table,
    Modal,
    Row,
    Col,
    Input,
    Radio,
    Select,
    message,
    Pagination,
    Upload,
    Icon,
    Tree
} from 'antd';
import *as Actions from "../../actions/sysMediaManagement"
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT, PIC_TYPE} from "../../constants/index"
import $ from "jquery";

const {TabPane} = Tabs;
const {confirm} = Modal;
const {Option} = Select;
const {TreeNode} = Tree;
const { TextArea } = Input;

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG文件！');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('Image must smaller than 20MB!');
    }
    return isJpgOrPng && isLt2M;
}

export default class ChangePasswordPolicy extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            start: 1,
            size: 10,
            addVisible: false,
            type: '0',
            total: 0,
            id: '',
            loading: false,
            weChatNextStep: false,
            columnInformation: false,
            dataSource: [],
            subtreeArray: [],
            ColumnInformationList: [],
            addBtn: true,
            mediaProps: {
                vsbIp: "",
                vsbPort: '',
                vsbClientId: '',
                vsbAccount: '',
                vsbPassword: ''
            },
            addMediaProps: {
                mediaName: '',
                mediaCode: '',
                platform: '',
                titlePic: '',
                value: '1',
            },
            addMedia: {
                owner: '',
                vsbIp: '',
                vsbPort: '',
                vsbAccount: '',
                vsbPassword: '',
                vsbCid: '',
            },
            weChat: {
                appid: '',
                appSecret: '',
                gzhtype: 1,
            }
        }
    }

    componentDidMount() {
        this.getMediaList();
    }

    getMediaList() {
        let parmas = {
            start: this.state.start,
            size: this.state.size,
            // type: this.state.type,
        };
        if (this.state.type !== '0') {
            parmas.type = this.state.type;
        }
        Actions.getMediaList(parmas, (json) => {
            // let json = JSON.parse(data);
            let list = json.data;
            console.log("data:", list);
            list.forEach((item,index)=>{
                item.key=index;
            });
            this.setState({total: json.count,dataSource: list});
        })
    }

    edit(record) {
        console.log(record);
        let addMediaJson = {};

        if(!record.mediaProperty){
            addMediaJson = {
                owner: "",
                vsbIp: "",
                vsbPort: "",
                vsbAccount: "",
                vsbPassword: "",
                vsbCid: "",
            };
        }else{
            addMediaJson = record.mediaProperty;
        }
        this.state.id = record.id;
        this.setAddVisible(true);
        this.setState({
            addMediaProps: {
                mediaName: record.name,
                mediaCode: record.code,
                platform: record.platform,
                value: record.type,
                titlePic: record.mediaLogo,
                description:record.description,
            },
        });
        if (record.type === 2) {
            this.setState({
                weChat: {
                    appid: addMediaJson.appid,
                    appSecret: addMediaJson.appSecret,
                    gzhtype: addMediaJson.gzhtype,
                }
            })
        } else if(record.type === 3||record.type === 5){
         let   addMedia=record.mediaProperty;
            this.setState({addMedia})
        }else {
            this.setState({
                addMedia: {
                    owner: addMediaJson.owner,
                    vsbIp: addMediaJson.vsbIp,
                    vsbPort: addMediaJson.vsbPort,
                    vsbAccount: addMediaJson.vsbAccount,
                    vsbPassword: addMediaJson.vsbPassword,
                    vsbCid: addMediaJson.vsbCid,
                }
            })
        }
    }

    render() {
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let margin = 15;
        let otherHeight = 240 + margin * 2;

        const loop = data => {
            if (data != '') {
                return data.map(item => {
                    if (item.subtree && item.subtree.length) {
                        return (
                            <TreeNode key={item.name} title={item.name}>
                                {loop(item.subtree)}
                            </TreeNode>
                        );
                    }
                    return <TreeNode key={item.name} title={item.name}/>;
                });
            }

        }
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                defaultSortOrder: 'ascend',
                sorter: (a, b) => a.id - b.id,
            },
            {
                title: '媒体名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '媒体编码',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: '媒体类型',
                dataIndex: 'type',
                render: (text, record) => {
                    if (text === 1) {
                        return '网站'
                    } else if (text === 2) {
                        return '微信'
                    } else if (text === 3) {
                        return '微博'
                    } else if (text === 5) {
                        return '抖音'
                    } else {
                        return '其他'
                    }
                },
            },
            {
                title: '操作',
                key: 'product',
                render: (text, record) => (
                    <span>
                        <a><Button size='small' style={{marginRight: 10,}} onClick={() => {
                            this.edit(record)
                        }}>修改</Button></a>
			        <a><Button size='small' type="danger" style={{marginRight: 10,}}
                               onClick={() => this.delete(record.id)}>删除</Button></a>
                        {
                            record.type === 1 ? <span><a><Button size='small' style={{marginRight: 10}}
                                                                 onClick={() => this.columnInformation(record.code)}>查看栏目树</Button></a>
						<a><Button size='small' style={{marginRight: 10}}
                                   onClick={() => this.viewColumnTree(record.code)}>更新栏目树</Button></a>
						<a onClick={() => this.showConfirm('single', record.code)}><Button size='small'
                                                                                           style={{marginRight: 10}}>同步稿件</Button></a></span> : null
                        }
                        {
                            [3,5].includes(record.type) ?
                                (!record.isAuth ? <a><Button size='small' onClick={() => this.authentication(this, record.id)}>认证</Button></a> : null) : null
                        }

			      </span>
                ),
            },
        ]
        const imgSrc = {
            '2': '/cm-sites/images/media2.jpg',
            '3': '/cm-sites/images/media3.jpg',
            '4': '/cm-sites/images/media5.jpg',
            '1': '/cm-sites/images/media1.jpg'
        }
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">上传</div>
            </div>
        )
        const {titlePic} = this.state.addMediaProps;
        return (
            <div>
                <Card title={'媒体管理'} style={{margin: margin}}>
                    <div>
                        <Button type="primary" style={{marginRight: 15}} onClick={() => {
                            this.setAddVisible(true);
                            this.setState({addBtn: true});
                            this.setState({addMediaProps: {platform: '1', titlePic: '', value: 1}})
                        }}>添加媒体</Button>
                        <Modal
                            title="添加媒体"
                            centered
                            destroyOnClose
                            okText={this.state.addMediaProps.value === 1 || this.state.addMediaProps.value === 2 ? '下一步' : '确定'}
                            visible={this.state.addVisible}
                            onOk={() => {
                                this.setAddVisible(false);

                            }}
                            onCancel={this.handleCancel}>
                            <div style={{display: 'flex', lineHeight: '32px'}}>
                                <div style={{marginRight: 15}}>媒体名称</div>
                                <div><Input value={this.state.addMediaProps.mediaName} placeholder="请输入媒体名称（不得超过10个字符"
                                            maxLength={10} style={{width: 400}}
                                            onChange={(e) => this.setAddMediaProps("mediaName", e.target.value)}/></div>
                            </div>
                            <div style={{display: 'flex', lineHeight: '32px', marginTop: 15,}}>
                                <div style={{marginRight: 15}}>媒体编码</div>
                                <div><Input value={this.state.addMediaProps.mediaCode} placeholder="请输入媒体编码"
                                            style={{width: 400}}
                                            disabled={this.state.addBtn === true ? false : true}
                                            onChange={(e) => this.setAddMediaProps("mediaCode", e.target.value)}/></div>
                            </div>

                            <div style={{display: 'flex', lineHeight: '32px', marginTop: 15,}}>
                                <div style={{marginRight: 15}}>媒体描述</div>
                                <div><TextArea value={this.state.addMediaProps.description} placeholder="请输入媒体描述"
                                               style={{width: 400}}
                                               rows={3}
                                               onChange={(e) => this.setAddMediaProps("description", e.target.value)}/></div>
                            </div>

                            <div style={{display: 'flex', lineHeight: '32px', marginTop: 15,}}>
                                <div style={{marginRight: 15}}>媒体平台</div>
                                <div>
                                    <Select
                                        showSearch
                                        style={{width: 400}}
                                        placeholder="直接选择"

                                        value={this.state.addMediaProps.platform}
                                        onChange={this.onChangeMediaPlatForm}
                                    >
                                        <Option value="1">传统媒体</Option>
                                        <Option value="2">中文资讯综合类</Option>
                                        <Option value="3">短视频类平台</Option>
                                        <Option value="4">英文媒体平台</Option>
                                    </Select>
                                </div>
                            </div>
                            <div style={{display: 'flex', lineHeight: '32px', marginTop: 15,}}>
                                <div style={{marginRight: 15}}>媒体类型</div>
                                <div style={{marginRight: 10}}>单选:</div>
                                <Radio.Group onChange={this.onChangeRadio} value={this.state.addMediaProps.value}
                                             disabled={this.state.addBtn === true ? false : true}
                                             style={{lineHeight: '32px'}}>
                                    <Radio value={1}>网站</Radio>
                                    <Radio value={2}>公众号</Radio>
                                    <Radio value={3}>微博</Radio>
                                    <Radio value={5}>抖音</Radio>
                                    <Radio value={6}>其他</Radio>
                                </Radio.Group>
                            </div>
                            <div style={{display: 'flex', lineHeight: '32px', marginTop: 15,}}>
                                <div style={{marginRight: 15}}>媒体logo</div>
                                <div>
                                    <Upload
                                        name="file"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action="/cm-sites-sys/ueditor/control?action=uploadimage"
                                        beforeUpload={beforeUpload}
                                        onChange={this.handleChange.bind(this)}
                                    >
                                        {titlePic ? <img src={titlePic} alt="avatar" style={{
                                            width: '103px',
                                            height: '103px',
                                            objectFit: 'cover'
                                        }}/> : uploadButton}
                                    </Upload>
                                </div>
                            </div>
                        </Modal>

                       {/* <Button type="primary" style={{marginRight: 15}} onClick={() => {
                            this.showModal();
                            this.setState({
                                mediaProps: {
                                    vsbIp: "",
                                    vsbPort: '',
                                    vsbClientId: '',
                                    vsbAccount: '',
                                    vsbPassword: ''
                                }
                            })
                        }}>同步网站</Button>*/}
                        <Modal
                            title="栏目信息"
                            centered
                            visible={this.state.columnInformation}
                            onOk={this.columnInformation}
                            onCancel={this.handleCancel}>
                            <div style={{height: '300px', background: 'white'}}>
                                <Scrollbars>
                                    {
                                        this.state.columnInformationList && this.state.columnInformationList.length > 0 &&
                                        <Tree
                                            className="draggable-tree"
                                            defaultExpandAll
                                            onExpand={() => {
                                            }}
                                        >
                                            {loop(this.state.columnInformationList)}
                                        </Tree>
                                    }
                                </Scrollbars>
                            </div>

                        </Modal>
                        <Modal
                            title="web其他配置"
                            centered
                            visible={this.state.nextStep}
                            onOk={this.nextStepOk}
                            onCancel={this.handleCancel}>
                            <div>
                                <div style={{textAlign: 'center'}}>
                                    <img src={imgSrc[this.state.addMediaProps.value]}/>
                                </div>
                                <div style={{textAlign: 'center'}}>请完善以下信息才能将稿件发布在此媒体中</div>
                                <div>
                                    <Input
                                        placeholder={this.state.addMediaProps.value === '1' ? '请输入网站owner' : '请输入网站序号'}
                                        value={this.state.addMedia.owner} style={{marginTop: 10}}
                                        onChange={(e) => this.setAddMedia("owner", e.target.value)}/>
                                    <Input placeholder="请输入网站群ip地址" style={{marginTop: 10}}
                                           value={this.state.addMedia.vsbIp}
                                           onChange={(e) => this.setAddMedia("vsbIp", e.target.value)}/>
                                    <Input placeholder="请输入网站群端口" style={{marginTop: 10}}
                                           value={this.state.addMedia.vsbPort}
                                           onChange={(e) => this.setAddMedia("vsbPort", e.target.value)}/>
                                    <Input placeholder="请输入与网站群对接的账号" style={{marginTop: 10}}
                                           value={this.state.addMedia.vsbAccount}
                                           onChange={(e) => this.setAddMedia("vsbAccount", e.target.value)}/>
                                    <Input placeholder="请输入与网站群对接的密码" style={{marginTop: 10}}
                                           value={this.state.addMedia.vsbPassword}
                                           onChange={(e) => this.setAddMedia("vsbPassword", e.target.value)}/>
                                    <Input placeholder="请输入与网站群对接的账号的id" style={{marginTop: 10}}
                                           value={this.state.addMedia.vsbCid}
                                           onChange={(e) => this.setAddMedia("vsbCid", e.target.value)}/>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            title="web其他配置"
                            centered
                            visible={this.state.weChatNextStep}
                            onOk={this.nextStepOk}
                            onCancel={this.handleCancel}>
                            <div>
                                <div style={{textAlign: 'center'}}>
                                    <img src={'/cm-sites/images/media2.jpg'}/>
                                </div>
                                <div style={{textAlign: 'center'}}>请完善以下信息才能将稿件发布在此媒体中</div>
                                <div style={{
                                    textAlign: 'center',
                                    color: 'red',
                                    fontSize: "13px",
                                    marginTop: 5
                                }}>注:填写完以下信息后请将资源管理平台服务器IP地址加入到微信开发平台白名单
                                </div>
                                <div style={{marginBottom: 10}}>
                                    <Input placeholder="请输入appId" value={this.state.weChat.appid}
                                           style={{marginTop: 10}}
                                           onChange={(e) => this.weChatSetAddMedia("appid", e.target.value)}/>
                                    <Input placeholder="请输入appSecret" value={this.state.weChat.appSecret}
                                           style={{marginTop: 10}}
                                           onChange={(e) => this.weChatSetAddMedia("appSecret", e.target.value)}/>
                                </div>
                                <span style={{marginRight: 10}}>公众类型:</span>

                                <Radio.Group value={parseInt(this.state.weChat.gzhtype)} onChange={this.onChangeWeChatRadio}
                                             style={{lineHeight: '32px'}}
                                             disabled={this.state.addBtn === true ? false : true}>
                                    <Radio value={1}>订阅号</Radio>
                                    <Radio value={2}>服务号</Radio>
                                </Radio.Group>
                            </div>
                        </Modal>
                        <Modal
                            title="同步站点"
                            centered
                            okText='同步'
                            visible={this.state.visible}
                            onOk={this.handleOk}
                            onCancel={this.handleCancel}
                        >
                            <Row style={{lineHeight: '32px'}}>
                                <Col span={5}>
                                    <div className="gutter-box">网站群IP</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder="请输入网站群管理机IP" value={this.state.mediaProps.vsbIp}

                                           onChange={(e) => this.setMediaProps("vsbIp", e.target.value)}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 15, lineHeight: '32px'}}>
                                <Col span={5}>
                                    <div className="gutter-box">网站群端口</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder="请输入网站群管理机端口" value={this.state.mediaProps.vsbPort}
                                           onChange={(e) => this.setMediaProps("vsbPort", e.target.value)}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 15, lineHeight: '32px'}}>
                                <Col span={5}>
                                    <div className="gutter-box">客户端ID</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder="请输入网站群客户端ID" value={this.state.mediaProps.vsbClientId}
                                           onChange={(e) => this.setMediaProps("vsbClientId", e.target.value)}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 15, lineHeight: '32px'}}>
                                <Col span={5}>
                                    <div className="gutter-box">客户端账号</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder="请输入网站群客户端账号" value={this.state.mediaProps.vsbAccount}
                                           onChange={(e) => this.setMediaProps("vsbAccount", e.target.value)}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 15, lineHeight: '32px'}}>
                                <Col span={5}>
                                    <div className="gutter-box">客户端密码</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder="请输入网站群客户端账号密码" value={this.state.mediaProps.vsbPassword}
                                           onChange={(e) => this.setMediaProps("vsbPassword", e.target.value)}/>
                                </Col>
                            </Row>
                        </Modal>
                       {/* <Button type="primary" onClick={() => this.showConfirm('all')}>同步所有稿件</Button>*/}
                    </div>
                    <Tabs activeKey={this.state.type} onChange={this.callback}>
                        <TabPane tab="全部" key="0"></TabPane>
                        <TabPane tab="网站" key="1"></TabPane>
                        <TabPane tab="微信" key="2"></TabPane>
                        <TabPane tab="微博" key="3"></TabPane>
                        <TabPane tab="抖音" key="5"></TabPane>
                        <TabPane tab="其他" key="6"></TabPane>
                    </Tabs>
                    <div style={{height: height - otherHeight}}><Scrollbars><Table pagination={false}
                                                                                   dataSource={this.state.dataSource}
                                                                                   columns={columns} bordered
                                                                                   onChange={this.onChange}/></Scrollbars>
                    </div>
                    <div>
                        <Pagination
                            style={{marginTop: 20}}
                            showQuickJumper
                            defaultCurrent={this.state.start}
                            current={this.state.start}
                            pageSize={this.state.size}
                            total={this.state.total}
                            showTotal={total => `共 ${total} 条`}
                            showSizeChanger
                            onChange={(page, pageSize) => this.onChangeList(page, pageSize)}
                            onShowSizeChange={(page, pageSize) => {
                                this.onChangeList(page, pageSize)
                            }}
                        />
                    </div>
                </Card>
            </div>
        )
    }

    callback = (key) => {
        this.setState({type: key}, () => {
            this.getMediaList()
        })
    }
    //媒体的类型
    onChangeMediaPlatForm = (value) => {
        this.state.addMediaProps.platform = value;
        this.setState({})
    }
    //上传图片
    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            let fileInfo = info.file.response;
            this.state.addMediaProps.titlePic = fileInfo.url;
            this.setState({loading: false})
        }
    };
    //添加媒体
    addMedia() {
        let params = {
            name: this.state.addMediaProps.mediaName,
            code: this.state.addMediaProps.mediaCode,
            type: this.state.addMediaProps.value,
            platform: this.state.addMediaProps.platform,
            mediaLogo: this.state.addMediaProps.titlePic,
            description:this.state.addMediaProps.description
        }
        if (this.state.addMediaProps.value == 2) {
            params.mediaProperty = JSON.stringify(this.state.weChat);

        } else {
            params.mediaProperty = JSON.stringify(this.state.addMedia);
        }
        if (this.state.id == '') {
            Actions.addmedia(params, (data) => {
                message.success('添加媒体成功');
                this.revert();
                this.getMediaList()
            })
        } else {
            params.id = this.state.id
            Actions.save(params, (data) => {
                message.success('修改成功');
                this.revert();
                this.getMediaList()
            })
        }
    }

    nextStepOk = e => {
        this.addMedia()
    }

    //清空数据
    revert() {
        this.setState({nextStep: false});
        this.setState({weChatNextStep: false});
        this.state.addMedia.owner = '';
        this.state.addMedia.vsbIp = '';
        this.state.addMedia.vsbPort = '';
        this.state.addMedia.vsbAccount = '';
        this.state.addMedia.vsbPassword = '';
        this.state.addMedia.vsbCid = '';
        this.state.weChat.appid = '';
        this.state.weChat.appSecret = '';
        this.setState({})
    }
    //认证
    authentication(obj, id) {
        Actions.authentication({id: id}, (data) => {
            let dataArray = (JSON.parse(data));
            if (data) {
                let keyCode = dataArray.keycode;
                let openUrl = dataArray.openurl;
                window.open(openUrl);
                this.isOAuthSuccess(obj, id, keyCode)
            } else {
                message.error('认证失败，请检查媒体信息!');
            }

        })
    }
    //是否认证
    isOAuthSuccess(obj, id, code) {
        let numberOfOAuth = 0;
        let that = this;
        Actions.isOAuthSuccess({id: id, code: code}, (data) => {
            if (data) {
                this.getMediaList();
            } else {
                if (numberOfOAuth < 100) {
                    /**反复验证*/
                    setTimeout(function () {
                        numberOfOAuth = numberOfOAuth + 1;
                        that.isOAuthSuccess(obj, id, code)
                    }, 3000);
                }
            }
        })
    }

    //添加类型的切换
    onChangeRadio = e => {
        this.state.addMediaProps.value = e.target.value;
        this.setState({})
    };
    //公众号单选框的切换
    onChangeWeChatRadio = e => {
        this.state.weChat.gzhtype = e.target.value;
        this.setState({})

    }
    //切换（网站，抖音，其他...）的list
    onChangeList(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        this.getMediaList()
    }
    //同步网站的value
    setMediaProps(propName, value) {
        this.state.mediaProps[propName] = value;
        this.setState({})
    }
    //公众号
    weChatSetAddMedia(propName, value) {
        this.state.weChat[propName] = value;
        this.setState({})
    }
    //添加媒体的value
    setAddMediaProps(propName, value) {
        this.state.addMediaProps[propName] = value;
        this.setState({})
    }
    //网站的下一步
    setAddMedia(propName, value) {
        this.state.addMedia[propName] = value;
        this.setState({});
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    //查看栏目树
    columnInformation(code) {
        Actions.columnInformation({code: code}, (data) => {
            let dataArray = [];
            dataArray.push(JSON.parse(data));
            //调用方法
            this.state.subtreeArray = [];
            this.setState({columnInformationList: dataArray});
            this.setState({columnInformation: true});
        }, (msg)=>{
            message.error(msg);
        })
    }
    //同步网站
    handleOk = e => {
        let params = {
            vsbIp: this.state.mediaProps.vsbIp,
            vsbPort: this.state.mediaProps.vsbPort,
            vsbClientId: this.state.mediaProps.vsbClientId,
            vsbAccount: this.state.mediaProps.vsbAccount,
            vsbPassword: this.state.mediaProps.vsbPassword
        }

        if ($.trim(this.state.mediaProps.vsbIp) == "") {
            message.warning('请输入网站群管理机IP');
            return
        }
        if ($.trim(this.state.mediaProps.vsbPort) == "") {
            message.warning('请输入网站群管理机端口');
            return
        }
        if ($.trim(this.state.mediaProps.vsbClientId) == "") {
            message.warning('请输入网站群客户端ID');
            return
        }
        if ($.trim(this.state.mediaProps.vsbAccount) == "") {
            message.warning('请输入网站群客户端账号');
            return
        }
        if ($.trim(this.state.mediaProps.vsbPassword) == "") {
            message.warning('请输入网站群客户端账号密码');
            return
        }
        Actions.syncsite(params, (data) => {
        })
        this.setState({
            visible: false,
        });
    };
    //点击取消
    handleCancel = e => {
        this.state.id = '';
        this.setState({});
        this.setState({
            visible: false,
            nextStep: false,
            addVisible: false,
            weChatNextStep: false,
            columnInformation: false,

        });

    };

    //点击下一步
    setAddVisible(addVisible) {
        if (this.state.id == '') {
            this.setState({addBtn: true,});
            this.setState({
                addMedia: {
                    owner: '',
                    vsbIp: '',
                    vsbPort: '',
                    vsbAccount: '',
                    vsbPassword: '',
                    vsbCid: '',
                },
                weChat: {
                    appid: '',
                    appSecret: '',
                    gzhtype: 1,
                },

            })
        } else {
            this.setState({addBtn: false,});
        }

        this.setState({addVisible});
        if (addVisible == false) {

            let parmas = {
                name: this.state.addMediaProps.mediaName,
                code: this.state.addMediaProps.mediaCode,
                platform: this.state.addMediaProps.platform,
                type: this.state.addMediaProps.value,
                mediaLogo: this.state.addMediaProps.titlePic,
            }
            if (this.state.addBtn == false) {

                parmas.id = this.state.id;
            }
            let codeReg = /^\d+$/;
            let codeReg1 = /^[a-zA-Z0-9_\-]+$/;//大小写字母、数字、下划线、减号任意组合
            if (codeReg.test($.trim(this.state.addMediaProps.mediaCode)) || !codeReg1.test($.trim(this.state.addMediaProps.mediaCode))) {
                message.warning('媒体编码只能为英文字母、数字、减号及下划线的组合，但不可为纯数字');
                this.setState({addVisible: true});
                return false;
            }

            if (this.state.addMediaProps.mediaName == '') {
                message.warning('媒体名称不能为空');
                this.setState({addVisible: true});
                return;
            }
            if (this.state.addMediaProps.platform == '') {
                message.warning('媒体平台不能为空');
                this.setState({addVisible: true});
                return;
            }
            if (this.state.addMediaProps.value == '' || this.state.addMediaProps.value == undefined) {
                message.warning('媒体类型不能为空');
                this.setState({addVisible: true});
                return;
            }
            if (this.state.addMediaProps.value == 1 || this.state.addMediaProps.value == 2) {
                Actions.checkmedia(parmas, (data) => {
                    if (data) {
                        if (this.state.addMediaProps.value == 1) {
                            this.setState({
                                nextStep: true,
                            });
                        } else if (this.state.addMediaProps.value == 2) {
                            this.setState({
                                weChatNextStep: true,
                            });
                        }
                    } else {
                        message.error(data.msg);
                    }
                })
            } else {
                this.addMedia()
            }

        }
    }

    viewColumnTree(name) {
        Actions.viewcolumntree({code: name}, (data) => {
        })
    };
    //删除
    delete(id) {
        let that = this;
        confirm({
            title: '信息',
            centered: 'centered',
            content: '确定删除该媒体吗？',
            onOk() {
                Actions.delMediaById({id: id}, (data) => {
                    if (data == true) {
                        message.success('删除成功');
                        that.getMediaList()
                    }
                })
            },
            onCancel() {
            },
        });
    }
    //确定同步稿件的弹框
    showConfirm(type, mediaCode) {
        confirm({
            title: '信息',
            centered: 'centered',
            content: type === 'all' ? '确定同步所有稿件' : '确定同步稿件',
            onOk() {
                if (type === 'all') {
                    Actions.synchronization((data) => {
                    })
                } else {
                    Actions.syncStory({mediaCode: mediaCode}, (data) => {
                       if(data){
                          message.info(data);
                       }
                    })
                }
            },
            onCancel() {
            },
        });
    }
}